import { render, staticRenderFns } from "./NvSpace.vue?vue&type=template&id=246865bc&"
import script from "./NvSpace.ts?vue&type=script&lang=ts&"
export * from "./NvSpace.ts?vue&type=script&lang=ts&"
import style0 from "./NvSpace.vue?vue&type=style&index=0&id=246865bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports